import React from 'react';
import "react-table/react-table.css";
import Select from 'react-select';
import 'react-day-picker/lib/style.css';
import './style.scss';
import FontAwesome from 'react-fontawesome';
import { filterNumber, getSum, getBoolColumn, removeRow } from '../../../gridHelpers/gridHelpers';
import NPReactTable from '../../../NPReactTable';
import Dialog from 'react-bootstrap-dialog';
import classHelper from '../../.././util/class.helper';
import * as Convert from '../../../util/unitConversion';

class CallOffItems extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasUnfinishedRow: false,
            currentExpand: '',
            expanded: {},
            page: 0,
            pageSize: 1000,
            resized: [],
            weightTotal: 0,
            quantityTotal: 0,
            orderByType: [{ label: 'Weight', value: 'W' }, { label: 'Quantity', value: 'Q' }]
        };
    }

    componentDidMount() {
        this.getcolumns = this.getcolumns.bind(this);
        this.addNewRow = this.addNewRow.bind(this);
        this.removeRowSuccess = this.removeRowSuccess.bind(this);
        this.calcWeightOrQuantity = this.calcWeightOrQuantity.bind(this);
        this.selectOrderRow = this.selectOrderRow.bind(this);
        this.getOrder = this.getOrder.bind(this);
        this.updateSums = this.updateSums.bind(this);
    }

    getOrder(index) {
        let obj = this.props.callOffItems.find(
            p => p.ORDER_NUMBER == this.props.callOffItems[index].ORDER_NUMBER
                && p.ORDER_ITEM_NUMBER == this.props.callOffItems[index].ORDER_ITEM_NUMBER
        );
        let tmp = obj && { label: obj.ORDER_COMBO, value: obj };
        return tmp;
    }

    addNewRow() {
        this.props.callOffItems.push({
            LOADING_NO: -1,
            ORDER_NUMBER: -1,
            ORDER_ITEM_NUMBER: -1,
            QUANTITY: 0,
            PLANNED_QUANTITY: 0,
            AVAILABLE_QUANTITY: 0,
            WEIGHT: 0,
            PLANNED_WEIGHT_UC: 0,
            AVAILABLE_WEIGHT_UC: 0
        });

        this.setState({
            hasUnfinishedRow: true
        });

        this.updateSums()
    }

    removeRowSuccess() {
        this.setState({
            hasUnfinishedRow: false
        });

        this.updateSums()
    }

    updateSums(datarow) {
        if (this.reactTable) {
            let data = this.reactTable.props.data;
            this.state.weightTotal = getSum(data, "PLANNED_WEIGHT_UC");
            this.state.quantityTotal = getSum(data, "PLANNED_QUANTITY");
            this.props.parentRefresh();
        }
        else if (datarow) {
            this.state.weightTotal = parseFloat(this.state.weightTotal) + parseFloat(datarow.PLANNED_WEIGHT_UC);
            this.state.quantityTotal = parseFloat(this.state.quantityTotal) + parseFloat(datarow.PLANNED_QUANTITY);
        }
        else {
            this.props.parentRefresh();
        }
    }

    selectOrderRow(target, row) {
        // Get selected order
        let selectedOrderItem = this.props.availableCallOffItems.find(c => c.ORDER_NUMBER == target.value.ORDER_NUMBER && c.ORDER_ITEM_NUMBER == target.value.ORDER_ITEM_NUMBER);

        if (this.props.callOffItems.length == 0)
            this.props.setEndCountry(selectedOrderItem.DELIVERY_DESTINATION);

        // Map selected order
        for (const prop in selectedOrderItem) {
            row.original[prop] = selectedOrderItem[prop]
        }

        // Map selected 'By'
        row.original.ORDERED_BY = selectedOrderItem.ORDERED_BY || { label: 'Quantity', value: 'Q' } // Quantity is default for new callOffOrders

        this.setState({
            hasUnfinishedRow: false
        })
    }

    calcWeightOrQuantity(datarow) {
        if (!datarow) return false

        const { AVAILABLE_WEIGHT_UC, AVAILABLE_QUANTITY, PLANNED_WEIGHT_UC, PLANNED_QUANTITY } = datarow

        let newPlannedWeight = PLANNED_WEIGHT_UC
        let newPlannedQuantity = PLANNED_QUANTITY

        if (datarow.ORDERED_BY.value == 'W') 
            if (datarow.PLANNED_WEIGHT_UC <= datarow.AVAILABLE_WEIGHT_UC)
                newPlannedQuantity = ((PLANNED_WEIGHT_UC / AVAILABLE_WEIGHT_UC) * AVAILABLE_QUANTITY).toFixed(0) == 0 ? 1 : ((PLANNED_WEIGHT_UC / AVAILABLE_WEIGHT_UC) * AVAILABLE_QUANTITY).toFixed(0) 

        if (datarow.ORDERED_BY.value == 'Q')
            if (datarow.PLANNED_QUANTITY <= datarow.AVAILABLE_QUANTITY)

            if (window.sessionStorage.getItem('UnitConversion') === "IMPERIAL") {
                newPlannedWeight = ((AVAILABLE_WEIGHT_UC / AVAILABLE_QUANTITY) * PLANNED_QUANTITY).toFixed(1)
            } else (
                newPlannedWeight = ((AVAILABLE_WEIGHT_UC / AVAILABLE_QUANTITY) * PLANNED_QUANTITY).toFixed(0)
            );    
              
        datarow.PLANNED_WEIGHT_UC = newPlannedWeight
        datarow.PLANNED_QUANTITY = newPlannedQuantity

        this.updateSums();
    }

    help() {
        alert('\u2795 Adds an order item\r\u2796 Removes an order item (after a confirmation question)\r \u25BC For extra information');
    }

    getcolumns() {
        const self = this;
        const greaseProofUser = window.sessionStorage.getItem('LegalEntity') === 'NP';
        const styleforNumbers = { width: '84px' };
        let { orderByType } = this.state;

        // Filter availableCallOffItems
        const selectedCallOffItems = this.props.callOffItems
        const availableCallOffItems = this.props.availableCallOffItems.reduce(function (filtered, order) {

            let hasDifferentOrderCombo = !selectedCallOffItems.find(o => o.ORDER_COMBO == order.ORDER_COMBO);

            let hasSamePalletLocationArea = greaseProofUser 
                ? true 
                : selectedCallOffItems.filter(o => o.ORDER_COMBO).length > 0
                    ? selectedCallOffItems.find(o => o.PALLET_LOCATION_AREA == order.PALLET_LOCATION_AREA) ? true : false
                    : true //Endast filtrera p� PALLET_LOCATION_AREA om det finns giltiga orderrader och för Kraft

            let hasSameContactCodeShipTo = selectedCallOffItems.filter(o => o.ORDER_COMBO).length > 0
                ? selectedCallOffItems.find(o => o.CONTACT_CODE_SHIP_TO == order.CONTACT_CODE_SHIP_TO) ? true : false
                : true //Endast filtrera p� CONTACT_CODE_SHIP_TO om det finns giltiga orderrader

            let hasSameLocationAreaFrom = greaseProofUser
                ? selectedCallOffItems.filter(o => o.ORDER_COMBO).length > 0 
                    ? selectedCallOffItems.find(o => o.LOCATION_AREA_FROM == order.LOCATION_AREA_FROM) ? true : false
                : true
                : true

            // Endast fylla valbara order items om de:
            // 1. Har en annan ORDER_COMBO (unika orderrader i calloff)
            // 2. Har samma PALLET_LOCATION_AREA som tidigare valda orderader för Kraft
            // 3. Har samma CONTACT_CODE_SHIP_TO som tidigare valda orderrader

            if (hasDifferentOrderCombo && hasSamePalletLocationArea && hasSameContactCodeShipTo && hasSameLocationAreaFrom) 
                filtered.push(({ label: order.ORDER_COMBO + ' - ' + order.PRODUCT_CODE, value: order }));

            return filtered;
        }, []);

        let availableCallOffItemsLoading = this.props.availableCallOffItemsLoading;
        let okToAddNewRow = (availableCallOffItems.length == 0 || selectedCallOffItems.filter(x => x.LOADING_NO == -1).length > 0) ? false : true
        let plusStyle = okToAddNewRow ? { color: 'black' } : { color: 'gray', cursor: 'not-allowed' };

        return [
            {
                Header: "Product",
                headerStyle: { background: '#EEEEEE' },
                columns: [
                    {
                        Header: props => <FontAwesome className="handy" name="question-circle" onClick={() => { this.help() }} />,
                        maxWidth: 35,
                        id: 'newRec',
                        sortable: false,
                        filterable: false,
                        resizable: false,
                        textAlign: "center",
                        id: 'orderItemNumber',
                        Cell: row => (
                            <div></div>
                        )
                    },
                    {
                        Header: props => <FontAwesome className="handy" name="plus" onClick={() => {
                            this.props.disabled === false && okToAddNewRow && this.addNewRow()
                        }} style={plusStyle} />,
                        maxWidth: 20,
                        filterable: false,
                        sortable: false,
                        id: 'addRemoveRow',
                        textAlign: "center",
                        resizable: false,
                        Cell: (props, row) =>
                            <span style={{ textAlign: "center" }}>
                                <FontAwesome className="handy" style={{ textAlign: "center" }} name="minus" onClick={() => {
                                    removeRow(this.props.callOffItems, props.row._original, this, this.removeRowSuccess, 'Remove order item', 'Do you really want to remove this order item?', props.row._original.ORDER_ITEM_STATUS === "B")
                                    }} />
                            </span>
                    },
                    {
                        Header: "Order number",
                        maxWidth: 140,
                        minWidth: 115,
                        id: 'orderNumbers',
                        Cell: row => (
                            <Select isSearchable={true}
                                styles={classHelper.dropdownStyleSmallMenu()}
                                isClearable={false}
                                isLoading={availableCallOffItemsLoading}
                                isDisabled={availableCallOffItemsLoading}
                                options={availableCallOffItems}
                                menuContainerStyle={{ zIndex: 5 }}
                                value={this.getOrder(row.index)}
                                onChange={value => this.selectOrderRow(value, row)}
                            />
                        )
                    },
                    {
                        Header: "Product code",
                        maxWidth: 125,
                        minWidth: 125,
                        id: 'type',
                        Cell: row => (
                            <div>{row.original.PRODUCT_CODE}</div>
                        )
                    },
                    {
                        Header: "Type",
                        maxWidth: 50,
                        id: 'type',
                        Cell: row => (
                            <div>{row.original.PT_DESCRIPTION}</div>
                        )
                    },
                    {
                        Header: "Grade Code",
                        maxWidth: 80,
                        id: 'Grade Code',
                        Cell: row => (
                            <div>{row.original.GRADE_CODE}</div>
                        )
                    },
                    {

                        Header: <Convert.TextTo value_metric={"Grammage"} value_imperial={"Basis weight"}/>,
                        maxWidth: 90,
                        textAlign: "right",
                        id:'BASIS_WEIGHT_UC',
                        Cell: row => (
                            <div><Convert.AddSymbol check={row.original.BASIS_WEIGHT_UC}/>{row.original.BASIS_WEIGHT_UC}</div>
                        )
                    },
                ]
            },
            {
                Header: "Order info",
                headerStyle: { background: '#EEEEEE' },
                columns: [

                    {
                        Header: 'Sales price',
                        maxWidth: 94,
                        id: 'salesPrice',
                        Cell: row => (
                            <div>{row.original.UNIT_PRICE_COMMITTED}</div>
                        )
                    },
                    {
                        Header: 'Price unit',
                        maxWidth: 80,
                        id: 'priceUnit',
                        accessor: 'PRICE_UNIT'
                    },
                    getBoolColumn('FSC', 'FSC', 40, this, true),
                    getBoolColumn('PEFC', 'PEFC', 60, this, true),
                    getBoolColumn('CW', 'CW_MARK', 40, this, true),
                    {
                        Header: "By",
                        id: 'by',
                        maxWidth: 120,
                        Cell: row => (
                            <Select searchable={true}
                                isDisabled={greaseProofUser == false}
                                style={{ width: "100%" }}
                                isClearable={false}
                                options={orderByType}
                                value={row.original.ORDERED_BY}
                                onChange={evt => {
                                    row.original.ORDERED_BY = evt;
                                    this.calcWeightOrQuantity(row.original);
                                    this.props.parentRefresh();
                                    self.setState({});
                                }}
                            />
                        )
                    },
                    {
                        Header: 'Available quantity',
                        accessor: "AVAILABLE_QUANTITY",
                        minWidth: 110,
                        id: 'AvailableQuantity',
                        filterMethod: filterNumber,
                        Cell: row => (
                            <div>{row.original.AVAILABLE_QUANTITY}</div>
                        )
                    },
                    {
                        Header: 'Quantity',
                        accessor: "PLANNED_QUANTITY",
                        maxWidth: 94,
                        id: 'Quantity',
                        filterMethod: filterNumber,
                        Cell: row => (
                            <input type="number" className="form-control input-sm"
                                disabled={row.original.ORDERED_BY?.value === 'W'}
                                step="1"
                                min="0"
                                max={row.original.AVAILABLE_QUANTITY}
                                style={styleforNumbers}
                                onChange={(e) => {
                                    row.original.PLANNED_QUANTITY = e.target.value;
                                    this.calcWeightOrQuantity(row.original);
                                    this.props.parentRefresh();
                                    self.setState({});
                                }}
                                value={row.original.PLANNED_QUANTITY} >
                            </input>
                        ),
                        Footer: (
                            <span>
                                <strong>{this.state.quantityTotal}</strong>
                            </span>
                        )
                    },
                    {
                        Header: <Convert.TextTo value_metric={"Available weight (kg)"} value_imperial={"Available weight (lb)"}/>,
                        accessor: "AVAILABLE_WEIGHT_UC",
                        minWidth: 120,
                        id: 'AvailableWeight_UC',
                        filterMethod: filterNumber,
                        Cell: row => (
                            <div>{row.original.AVAILABLE_WEIGHT_UC}</div>
                        )
                    },
                    {
                        Header: <Convert.TextTo value_metric={"Weight (kg)"} value_imperial={"Weight (lb)"}/>,
                        accessor: "PLANNED_WEIGHT_UC",
                        minWidth: 100,
                        id: 'Weight',
                        filterMethod: filterNumber,
                        Cell: row => (
                            <input type="number" className="form-control input-sm"
                                disabled={row.original.ORDERED_BY?.value != 'W'}
                                style={styleforNumbers}
                                step="1"
                                min="0"
                                max={row.original.AVAILABLE_WEIGHT_UC}
                                onChange={(e) => {
                                    row.original.PLANNED_WEIGHT_UC = e.target.value;
                                    this.calcWeightOrQuantity(row.original);
                                    this.props.parentRefresh();
                                    self.setState({});
                                }}
                                value={row.original.PLANNED_WEIGHT_UC} >
                            </input>
                        ),
                        Footer: (
                            <span>
                                <strong>{this.state.weightTotal}</strong>
                            </span>
                        )
                    }
                ]
            },
            {
                header: "Delivery Time",
                columns: [
                    {
                        Header: "Exmill week",
                        maxWidth: 90,
                        minWidth: 90,
                        id: "week",
                        Cell: row => (
                            <div>{row.original['DELIVERYTIME_WEEK'] || ''}</div>
                        )
                    }
                ]
            }
        ];
    }

    render() {
        return (
            <div>
                <Dialog ref={(el) => { this.dialog = el }} />
                <NPReactTable
                    onFetchData={(state, instance) => {

                    }}
                    getTdProps={(state, rowInfo, column, instance) => {
                        return {
                            style: {
                                overflow: 'visible'
                            }
                        }
                    }}
                    className="margin-top-5 np-react-table"
                    data={this.props.callOffItems}
                    ref={(r) => { this.reactTable = r }}
                    showPagination={false}
                    showPageSizeOptions={false}
                    minRows={5}
                    columns={this.getcolumns()}
                    defaultPageSize={10000}
                    sorted={this.state.sorted}
                    page={this.state.page}
                    pageSize={this.state.pageSize}
                    expanded={this.state.expanded}
                    resized={this.state.resized}
                    onResizedChange={resized => { this.setState({ resized }) }}
                    onPageChange={
                        page => {
                            this.setState({ page, expanded: {} });
                        }
                    }
                    onPageSizeChange={(pageSize, page) => {
                        this.setState({ page, pageSize, expanded: {} });
                    }}
                />
            </div>
        );
    }
}

export default CallOffItems;